import { ContentfulFeatureToggle, ToggleType } from '../types';
import { FeatureToggle } from '../models/FeatureToggle';
import { RoutingToggleStrategy } from '../strategies/RoutingToggleStrategy';
import { DefaultToggleStrategy } from '../strategies/DefaultToggleStrategy';
import { FeatureToggleStrategy } from '../strategies/FeatureToggleStrategy';

const toggleMap = {
  [ToggleType.ROUTING]: new RoutingToggleStrategy(),
  [ToggleType.DEFAULT]: new DefaultToggleStrategy(),
};

export function createFeatureToggle<T>(
  contentfulToggle: ContentfulFeatureToggle<T>,
): FeatureToggle<T, any> {
  const toggle = new FeatureToggle<T, any>(
    contentfulToggle,
    getStrategy(contentfulToggle),
  );

  if (!toggle.isValidToggle()) {
    throw new Error(
      `Conflict type vs value for toggle: "${contentfulToggle.sys.id}"`,
    );
  }

  return toggle;
}

function getStrategy(
  contentfulToggle: ContentfulFeatureToggle<any>,
): FeatureToggleStrategy<any> {
  return (
    toggleMap[contentfulToggle.fields.hybridFeatureToggle_value?.type] ??
    toggleMap[ToggleType.DEFAULT]
  );
}
